import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    creating: -1,
    getDetails: -1,
  },
  data: null,
  list: [],
  fee: null,
  meta: null,
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error, meta } = action;

  const isLoadMore = meta?.isLoadMore ?? false;

  switch (type) {
    case ACTION_TYPES.MEMO_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 0,
        },
      };
    case ACTION_TYPES.MEMO_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.MEMO_CREATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 2,
        },
        error,
      };
    case ACTION_TYPES.MEMO_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          getDetails: 0,
        },
      };
    case ACTION_TYPES.MEMO_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          getDetails: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.MEMO_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          getDetails: 2,
        },
        error,
      };
    case ACTION_TYPES.MEMOS_GET_SUCCEED:
      return {
        ...state,
        list: isLoadMore ? [...state.list, ...payload.data] : payload.data,
        meta: payload.meta,
      };
    case ACTION_TYPES.MEMO_FEE_UPDATE_SUCCEED:
      return {
        ...state,
        fee: payload.data,
      };
    default:
      return state;
  }
}
